import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { getNumberValidFilter } from '@anytag/shared-utils';
import { GenderField, KeywordField, InfluencerTabField, CountriesField } from '../../shared';
import { BasicFilterDefaultProps } from '../../schemaTypes';
import { DouyinInfluencersFilterFormKeys, DouyinInfluencersFilterFormValues } from '../schemaTypes';
import { DouyinMoreFilter } from './AdvancedFilter';

export const BasicFilter = ({ onSubmit, isEngagementPage, isPackagePage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<DouyinInfluencersFilterFormValues>();

  const values = watch();
  const numOfValidFilter = getNumberValidFilter<DouyinInfluencersFilterFormKeys>(values, [
    'tab',
    'keyword',
    'genders',
    'includeIds',
    'countryIds'
  ]);

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} onSubmit={onSubmit} />
      <KeywordField placeholder={t<string>('Search.InfluencerSocialFilter')} onSubmit={onSubmit} searchByCategories />
      <GenderField onSubmit={onSubmit} css={{ maxWidth: '123px' }} />
      <CountriesField onSubmit={onSubmit} />
      <DouyinMoreFilter count={numOfValidFilter} onSubmit={onSubmit} isEngagementPage={isEngagementPage} />
    </Form.Fields>
  );
};
